export default __webpack_public_path__ + "static/media/more-icon.f51df4cd.svg";